import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { getPageTitle } from "../common/utilities/routes/page-title.util";

/**
 * Keeps `document.title` in sync with the active route so each page has a
 * unique, descriptive title (WCAG 2.4.2 Page Titled). Renders nothing.
 * Must be mounted inside the router.
 */
export const DocumentTitle = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const page = getPageTitle(pathname);
        document.title = page ? `${page} · MBAssist` : "MBAssist";
    }, [pathname]);

    return null;
};

export default DocumentTitle;
